// CRITICAL: pin ALL Date locale formatting to the venue timezone (IST) BEFORE any
// render, so wedding/event dates never show the previous day for non-IST viewers.
// See client/src/lib/istDateDefault.ts. Numbers (currency) are unaffected.
import { installIstDateDefault } from "./lib/istDateDefault";
installIstDateDefault();

// CRITICAL: Initialize Sentry BEFORE React renders
import { initSentry } from "./lib/sentry";
initSentry();

import { createRoot } from "react-dom/client";
import App from "./App";
// A session that ends while the portal is open goes to sign-in, not "Check your connection" (R6-9).
import { installSessionWatch } from "./lib/sessionWatch";
installSessionWatch(() => [window.location.origin]);
import "./index.css";

console.log('🚀 Main.tsx executing - React app starting');

const rootElement = document.getElementById("root");
if (!rootElement) {
  console.error('❌ Root element not found!');
} else {
  console.log('✅ Root element found, rendering app');
  createRoot(rootElement).render(<App />);
}
